import { combineReducers } from "redux";
import keyResourcesReducer from "./keyResources";
import locationResourcesReducer from "./locationResources";
import locationsReducer from "./locations";
import remediesReducer from "./remedies";
import remedyReducer from "./remedy";
import trackReducer from "./track";
import stories from "./stories";
import uiReducer from "./ui";

export default combineReducers({
  remedies: remediesReducer,
  remedy: remedyReducer,
  locations: locationsReducer,
  locationResources:locationResourcesReducer,
  keyResources:keyResourcesReducer,
  track:trackReducer,
  stories:stories,
  ui: uiReducer,
});
